import { constants } from "@newsela/angelou";

const { colors } = constants;
const darkBlue = colors.ui.core[700];

export const wrapperCss = {
  display: "flex",
  gap: 16,
};

export const textCss = {
  color: darkBlue,
  textTransform: "capitalize",
};

export const iconCss = {
  path: { stroke: darkBlue },
};
